import * as moment from "moment";
import * as constants from "./constants";
import * as models from "../models";
import * as modelsGet from "../models/get";
import { Time } from "../types/time";
import { InputMask } from "../components/input";
import { InputValueType } from "../enumerations";
import Inputmask from "inputmask";

/**
 * Konvertiert den übergebenen Wert in den übergebenen generic type.
 * @param value Der Wert der konvertiert werden soll.
 */
export function parseValue<T>(value: string, zeroIsUndefined: boolean = false, timeAsString: boolean = false): T
{
    var returnVal: any = undefined;

    if (value != null)
    {
        if (value.toLowerCase() === "true")
        {
            returnVal = <T><any>true;
        }
        else if (value.toLowerCase() === "false")
        {
            returnVal = <T><any>false;
        }
        else if ((value as string).match(constants.REGEX_DATE))
        {
            returnVal = <T><any>moment(value, "DD.MM.YYYY");
        }
        else if ((value as string).match(constants.REGEX_DATE_ISO))
        {
            returnVal = <T><any>moment(value);
        }
        else if ((value as string).match(constants.REGEX_TIME))
        {
            returnVal = <T><any>Time.parse(value);

            if (timeAsString)
                returnVal = returnVal.toString();
        }
        else if ((value as string).match(constants.REGEX_NUMBER))
        {
            returnVal = parseInt(value);
            if (returnVal === 0 && zeroIsUndefined)
                returnVal = undefined;
        }
        else
        {
            if (typeof value === "string" && value !== "")
            {
                returnVal = <T><any>value;
            }
        }
    }

    return <T>returnVal;
}

export function parseArray<T>(values: any[], zeroIsUndefined: boolean = false, timeAsString: boolean = false): T[]
{
    var returnVal: T[] = [];

    if (values != null && values.length > 0)
    {
        for (var i = 0; i < values.length; i++)
        {
            returnVal.push(parseValue<T>(values[i], zeroIsUndefined, timeAsString));
        }
    }

    return returnVal;
}

/**
 * Generates UUID v4
 * @node There is a bug in Chrome's Math.random() according to http://devoluk.com/google-chrome-math-random-issue.html
 *       For that reason we use Date.now() as well.
 */
export function UUID(): string
{
    function s(n) { return h((Math.random() * (1 << (n << 2))) ^ Date.now()).slice(-n); }
    function h(n) { return (n | 0).toString(16); }
    return [
        s(4) + s(4), s(4),
        '4' + s(3),                    // UUID version 4
        h(8 | (Math.random() * 4)) + s(3), // {8|9|A|B}xxx
        // s(4) + s(4) + s(4),
        Date.now().toString(16).slice(-10) + s(2) // Use timestamp to avoid collisions
    ].join('-');
}

/**
 * Gibt die größe der Scrollbar.
 */
export function getScrollBarWidth()
{
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return (w1 - w2);
};

/**
 * Generiert ein JSON-Objekt anhand aller Eingabefelder die sich im "parent" befinden.
 * @param parent
 */
export function convertFormToJson(parent: JQuery.PlainObject<any>): any
{
    var inputs: JQuery = $(parent).find("input, select, textarea");
    var json = {};
    inputs.each((index, elem) =>
    {
        if (elem.hasAttribute("data-jsonignore"))
            return false;

        var input: JQuery = $(elem);

        // Wert des input-Elements ermitteln.
        var inputValue = input.val();
        if (input.attr("type") === "checkbox")
            inputValue = (input[0] as any).checked.toString();

        if (input.attr("type") === "number")
        {
            inputValue = (input[0] as any).valueAsNumber as number;
            if (isNaN(inputValue))
                inputValue = undefined;
            else if (inputValue != null)
                inputValue = inputValue.toString();
        }

        // JsonPropertyName für des input-Elements ermitteln.
        var inputName: string;
        var hasJsonProp: boolean = elem.hasAttribute("data-jsonproperty");
        if (hasJsonProp)
        {
            inputName = input.attr("data-jsonproperty");
        }
        else
        {
            inputName = input.attr("name");
        }

        // Element auslassen wenn kein JsonPropertyName vorhanden ist.
        // Sonst Name evtl. parsen.
        if (inputName == null || (typeof inputName === "string" && inputName === ""))
        {
            return false;
        }
        else
        {
            if (!hasJsonProp && inputName !== "__RequestVerificationToken")
                inputName = inputName.splitJoinByCaps("_");
        }

        // Element auslaussen wenn es keinen Wert hat.
        if (inputValue == null || (typeof inputValue === "string" && inputValue === ""))
            return false;

        // Wert des Elements parsen.
        if (Array.isArray(inputValue))
        {
            var newArray = [];
            for (var val of inputValue)
            {
                newArray.push(parseValue(val, false, true));
            }

            json[inputName] = newArray;
        }
        else
        {
            json[inputName] = parseValue(inputValue.toString(), false, true);
        }
    });

    return json;
}

/**
 * Ermittelt die genaue Pixelanzahl anhand der übergebenen Minuten.
 * @param minutes Die Minuten die in Pixel umgerechnet werden sollen.
 * @param pixels Die Pixel die für das ermitteln der genauen Minuten benötigt wird.
 * Wird hier nichts angegeben, wird der Standardwert von einer Stunde genommen. Eine Stunde entspricht 68 Pixel.
 */
export function getPixelOutOfMinutes(minutes: number, pixels: number = 68): number
{
    return pixels / 60 * minutes;
}

/**
 * Kalkuliert die Länge der Rüstzeit bis zum Start des nächst möglichen Termins.
 * @param setuptime
 * @param duration
 * @param interval
 */
export function calculateSetuptime(setuptime: number, duration: number, interval: number): number
{
    var x: number = setuptime + interval;
    var y: number = duration - interval;
    var z: number = 0;
    var newSetuptime: number = setuptime;

    if (duration > interval)
    {
        do 
        {
            if (z + (x - y) >= 0)
            {
                newSetuptime = (z + (x - y)) + setuptime;
                break;
            }
            else
            {
                z = z + x;
            }
        } while (true);
    }

    return newSetuptime;
}

/**
 * Gibt die momentane Maus Position zurück.
 * @param e Das Event mit der die Position ermittelt werden soll.
 */
export function getMousePosition(e: MouseEvent): { x: number, y: number }
{
    const pos = {
        x: 0,
        y: 0
    };

    if (e.pageX)
    {
        pos.x = e.pageX;
    }
    else if (e.clientX)
    {
        pos.x = e.clientX + (document.documentElement.scrollLeft || document.body.scrollLeft);
    }

    if (e.pageY)
    {
        pos.y = e.pageY;
    }
    else if (e.clientY)
    {
        pos.y = e.clientY + (document.documentElement.scrollLeft || document.body.scrollLeft);
    }

    if (pos.x == null || pos.x < 0)
    {
        pos.x = 0;
    }

    if (pos.y == null || pos.y < 0)
    {
        pos.y = 0;
    }

    return pos;
}

export function getPagination(model: modelsGet.IPagedResultPaging): models.IPage[]
{
    var pages: models.IPage[] = [];
    var previousPageNo: number = 0;
    var nextPageNo: number = 0;
    var firstPageNo: number = 0;
    var lastPageNo: number = 0;
    var currentPageNo: number = 1;
    var uriHelper: uri.URI = new URI(model.first_page);

    if (model.previous_page != null)
    {
        let previousPage = new URI(model.previous_page);
        previousPageNo = previousPage.getQueryParameterValue<number>("pageNo");
    }

    if (model.next_page != null)
    {
        let nextPage = new URI(model.next_page);
        nextPageNo = nextPage.getQueryParameterValue<number>("pageNo");
    }

    if (model.first_page != null)
    {
        let firstPage = new URI(model.first_page);
        firstPageNo = firstPage.getQueryParameterValue<number>("pageNo");
    }

    if (model.last_page != null)
    {
        let lastPage = new URI(model.last_page);
        lastPageNo = lastPage.getQueryParameterValue<number>("pageNo");
    }

    if (nextPageNo === 0)
    {
        currentPageNo = lastPageNo;
    }
    else
    {
        currentPageNo = nextPageNo - 1;
    }

    pages.push({
        page: "Vorherige",
        isCurrent: false,
        isGap: false,
        href: model.previous_page
    });

    for (var i = 1; i <= lastPageNo; i++)
    {
        if (currentPageNo >= 1 && currentPageNo <= 4)
        {
            if (i > 5 && i < lastPageNo)
            {
                if (!pages.any(p => p.isGap))
                {
                    pages.push({
                        page: "...",
                        isCurrent: false,
                        isGap: true,
                        href: null
                    });
                }

                continue;
            }
        }
        else if (currentPageNo >= 5 && currentPageNo <= (lastPageNo - 4))
        {
            if (i > 1 && i < currentPageNo - 2)
            {
                if (!pages.any(p => p.isGap))
                {
                    pages.push({
                        page: "...",
                        isCurrent: false,
                        isGap: true,
                        href: null
                    });
                }

                continue;
            }
            else if (i > currentPageNo + 2 && i < lastPageNo)
            {
                if (pages.where(p => p.isGap).length === 1)
                {
                    pages.push({
                        page: "...",
                        isCurrent: false,
                        isGap: true,
                        href: null
                    });
                }

                continue;
            }
        }
        else if (currentPageNo >= (lastPageNo - 4))
        {
            if (i > 1 && i < lastPageNo - 4)
            {
                if (!pages.any(p => p.isGap))
                {
                    pages.push({
                        page: "...",
                        isCurrent: false,
                        isGap: true,
                        href: null
                    });
                }

                continue;
            }
        }

        pages.push({
            page: i.toString(),
            isCurrent: i === currentPageNo,
            isGap: false,
            href: uriHelper.setQuery("pageNo", i.toString()).href()
        });
    }

    pages.push({
        page: "Nächste",
        isCurrent: false,
        isGap: false,
        href: model.next_page
    });

    return pages;
}

export function getValue<T>(type: string, valueType: InputValueType, input: HTMLElement): { value: T[], originalValue: string[] }
{
    var value: string[] = [];

    // Wert des Inputs ermitteln.
    if (type === "select-multiple")
    {
        let target = input as HTMLSelectElement;

        if (target.selectedOptions.length > 0)
        {
            for (var i = 0; i < target.selectedOptions.length; i++)
            {
                var selectedVal: string = target.selectedOptions.item(i).value;
                if (selectedVal !== "--")
                {
                    value.push(target.selectedOptions.item(i).value);
                }
            }
        }
    }
    else if (type === "checkbox")
    {
        let target = input as HTMLInputElement;
        value.push(target.checked ? "true" : "false");
    }
    else
    {
        let target = input as HTMLInputElement;
        value.push(target.value);
    }

    switch (valueType)
    {
        case InputValueType.string:
            {
                if (value.length === 1)
                {
                    return {
                        value: <T[]><any>value,
                        originalValue: value
                    }
                }
                else if (value.length > 1)
                {
                    return {
                        value: <T[]><any>value,
                        originalValue: value
                    }
                }
            }
            break;
        case InputValueType.number:
            {
                if (value.length === 1)
                {
                    return {
                        value: parseArray<T>(value),
                        originalValue: value
                    }
                }
                else if (value.length > 1)
                {
                    return {
                        value: parseArray<T>(value),
                        originalValue: value
                    }
                }
            }
            break;
        case InputValueType.boolean:
            {
                if (value.length === 1)
                {
                    return {
                        value: parseArray<T>(value),
                        originalValue: value
                    }
                }
                else if (value.length > 1)
                {
                    return {
                        value: parseArray<T>(value),
                        originalValue: value
                    }
                }
            }
            break;
    }
}

export function isTextSelected(input: HTMLInputElement): boolean
{
    var startPos: number = input.selectionStart;
    var endPos: number = input.selectionEnd;

    if (input.value.substring(startPos, endPos).length != 0)
        return true;

    return false;
}

/**
 * Gibt den Inline-Style für die Definition von Grid Spalten.
 * @param columns Angabe der Spalten.
 */
export function getGridColumnsStyle(columns: string): models.IGridStyle
{
    return {
        msGridColumns: columns,
        gridTemplateColumns: columns
    }
}

/**
 * Gibt den Inline-Style für die Definition von Grid Spalten.
 * @param count Anzahl der Spalten.
 * @param column Angabe der Spalten Breite.
 */
export function getGridColumnsStyleRepeat(count: number, column: string): models.IGridStyle
{
    var columns: string[] = [];
    for (var i = 0; i < count; i++)
    {
        columns.push(column);
    }

    return {
        msGridColumns: columns.join(" "),
        gridTemplateColumns: columns.join(" ")
    }
}

/**
 * Gibt den Inline-Style für die Definition von Grid Zeilen.
 * @param rows Angabe der Zeilen.
 */
export function getGridRowsStyle(rows: string): models.IGridStyle
{
    return {
        msGridRows: rows,
        gridTemplateRows: rows
    }
}

/**
 * Gibt den Inline-Style für die Definition von Grid Zeilen.
 * @param count Anzahl der Zeilen.
 * @param row Angabe der Zeilen Höhe.
 */
export function getGridRowsStyleRepeat(count: number, row: string): models.IGridStyle
{
    var rows: string[] = [];
    for (var i = 0; i < count; i++)
    {
        rows.push(row);
    }

    return {
        msGridRows: rows.join(" "),
        gridTemplateRows: rows.join(" ")
    }
}

/**
 * Gibt den Inline-Style für die Grid Position eines Child Elements zurück.
 * @param columnStart Die Spaltenposition (Anfang).
 * @param columnEnd Die Spaltenposition (Ende).
 * @param rowStart Die Zeilenposition (Anfang).
 * @param rowEnd Die Zeilenposition (Ende).
 */
export function getGridChildStyle(columnStart: number, columnEnd: number, rowStart: number, rowEnd: number): models.IGridStyle
{
    return {
        msGridColumn: columnStart,
        msGridColumnSpan: ((columnEnd - columnStart <= 0) ? undefined : columnEnd - columnStart),
        msGridRow: rowStart,
        msGridRowSpan: ((rowEnd - rowStart <= 0) ? undefined : rowEnd - rowStart),
        gridColumn: columnStart + "/" + columnEnd,
        gridRow: rowStart + "/" + rowEnd
    }
}

export function isValid(value: string, type: InputMask): boolean
{
    return Inputmask.isValid(value, { alias: type });
}

export function getErrors(exception: any): Object
{
    if (exception != null && exception.responseJSON == null)
    {
        console.error(exception);
        return {
            internal_server_error: ""
        };
    }

    if (exception != null && exception.responseJSON != null)
    {
        var errors = exception.responseJSON;
        var newErrors = {};
        var alertMessage: string;

        for (let error in errors)
        {
            if (errors[error] != null && errors[error].length > 0)
                newErrors[error] = errors[error].first();
        }

        return newErrors;
    }
}

/**
 * Compares two software version numbers (e.g. "1.7.1" or "1.2b").
 *
 * This function was born in http://stackoverflow.com/a/6832721.
 *
 * @param {string} v1 The first version to be compared.
 * @param {string} v2 The second version to be compared.
 * @param {object} [options] Optional flags that affect comparison behavior:
 * lexicographical: (true/[false]) compares each part of the version strings lexicographically instead of naturally; 
 *                  this allows suffixes such as "b" or "dev" but will cause "1.10" to be considered smaller than "1.2".
 * zeroExtend: ([true]/false) changes the result if one version string has less parts than the other. In
 *             this case the shorter string will be padded with "zero" parts instead of being considered smaller.
 *
 * @returns {number|NaN}
 * - 0 if the versions are equal
 * - a negative integer iff v1 < v2
 * - a positive integer iff v1 > v2
 * - NaN if either version string is in the wrong format
 */
export function versionCompare(v1, v2, options = null)
{
    var lexicographical = (options && options.lexicographical) || false,
        zeroExtend = (options && options.zeroExtend) || true,
        v1parts = (v1 || "0").split('.'),
        v2parts = (v2 || "0").split('.');

    function isValidPart(x)
    {
        return (lexicographical ? /^\d+[A-Za-zαß]*$/ : /^\d+[A-Za-zαß]?$/).test(x);
    }

    if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart))
    {
        return NaN;
    }

    if (zeroExtend)
    {
        while (v1parts.length < v2parts.length) v1parts.push("0");
        while (v2parts.length < v1parts.length) v2parts.push("0");
    }

    if (!lexicographical)
    {
        v1parts = v1parts.map(function(x)
        {
            var match = (/[A-Za-zαß]/).exec(x);
            return Number(match ? x.replace(match[0], "." + x.charCodeAt(match.index)) : x);
        });
        v2parts = v2parts.map(function(x)
        {
            var match = (/[A-Za-zαß]/).exec(x);
            return Number(match ? x.replace(match[0], "." + x.charCodeAt(match.index)) : x);
        });
    }

    for (var i = 0; i < v1parts.length; ++i)
    {
        if (v2parts.length == i)
        {
            return 1;
        }

        if (v1parts[i] == v2parts[i])
        {
            continue;
        }
        else if (v1parts[i] > v2parts[i])
        {
            return 1;
        }
        else
        {
            return -1;
        }
    }

    if (v1parts.length != v2parts.length)
    {
        return -1;
    }

    return 0;
}